import React from "react";
import dayjs from "dayjs";
import styles from "./GroupAcessos.module.css";

/** Um par rótulo/valor. Mostra um placeholder em itálico quando o dado não veio preenchido. */
function Campo({ rotulo, valor, largo }) {
  const vazio = valor === null || valor === undefined || valor === "";
  return (
    <div className={`${styles.campo} ${largo ? styles.campoLargo : ""}`}>
      <span className={styles.rotulo}>{rotulo}</span>
      <span className={vazio ? styles.valorVazio : styles.valor}>{vazio ? "Não informado" : valor}</span>
    </div>
  );
}

/** Mesmo Campo, mas formatando a data (dd/mm/aaaa hh:mm:ss) quando ela existir. */
function CampoData({ rotulo, valor }) {
  const data = valor ? dayjs(valor) : null;
  const valido = data && data.isValid();
  return <Campo rotulo={rotulo} valor={valido ? data.format("DD/MM/YYYY HH:mm:ss") : null} />;
}

/** Campo booleano (Sim/Não), mostrado como badge em vez de checkbox desabilitado. */
function CampoBadge({ rotulo, valor }) {
  const indefinido = valor === null || valor === undefined;
  return (
    <div className={styles.campo}>
      <span className={styles.rotulo}>{rotulo}</span>
      <span
        className={`${styles.badge} ${
          indefinido ? styles.badgeIndefinido : valor ? styles.badgeSim : styles.badgeNao
        }`}
      >
        {indefinido ? "Não informado" : valor ? "Sim" : "Não"}
      </span>
    </div>
  );
}

const OPCOES_MODALIDADE_CERTIFICADO = [
  { value: "eCNPJ", label: "e-CNPJ preferível" },
  { value: "eCNPJ ", label: "e-CPF" },
];
const OPCOES_TIPO_CERTIFICADO = [
  { value: "A1", label: "Tipo A1" },
  { value: "A2", label: "Tipo A2" },
];

export function GroupAcessos({ info }) {
  const rotuloModalidade =
    OPCOES_MODALIDADE_CERTIFICADO.find((o) => o.value === info.certificadoModalidade)?.label || info.certificadoModalidade;
  const rotuloTipoCertificado =
    OPCOES_TIPO_CERTIFICADO.find((o) => o.value === info.certificadoTipo)?.label || info.certificadoTipo;

  return (
    <div className={styles.painel}>
      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Credenciais de acesso</h4>
        <div className={styles.grade}>
          <CampoBadge rotulo="Procuração Digital" valor={info.procuracaoDigital} />
          <CampoBadge rotulo="Certificação Digital" valor={info.certificadoCedido} />
          <CampoBadge rotulo="Acesso Remoto" valor={info.acessoContador} />
        </div>
      </div>

      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Certificado digital</h4>
        <div className={styles.grade}>
          <CampoData rotulo="Data Início Vigência" valor={info.dataAbertura} />
          <CampoData rotulo="Data Término Vigência" valor={info.dataEncerramento} />
          <Campo rotulo="Situação IE" valor={info.situacaoIE} />
          <Campo rotulo="Modalidade do Certificado" valor={rotuloModalidade} />
          <Campo rotulo="Tipo de Certificado" valor={rotuloTipoCertificado} />
          <Campo rotulo="Senha Certificado" valor={info.certificadoSenha} />
          <Campo rotulo="Data Expiração do Certificado" valor={info.certificadoDataExpiracao} />
        </div>
      </div>

      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Simples Nacional</h4>
        <div className={styles.grade}>
          <Campo rotulo="Código Acesso SN" valor={info.codigoAcessoSN} />
          <Campo rotulo="CPF de Acesso SN" valor={info.cpfAcessoSN} />
          <Campo rotulo="Penúltimo Recibo IRPF" valor={info.codigoReciboIRPF1} />
          <Campo rotulo="Último Recibo IRPF" valor={info.codigoReciboIRPF2} />
        </div>
      </div>

      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Acesso Gov / eCAC / Empregador Web</h4>
        <div className={styles.grade}>
          <Campo rotulo="Código Acesso Gov" valor={info.codigoAcessoGov} />
          <Campo rotulo="Senha Acesso Gov" valor={info.senhaAcessoGov} />
          <Campo rotulo="Código Acesso eCAC" valor={info.codigoAcessoECAC} />
          <Campo rotulo="Senha Acesso eCAC" valor={info.senhaAcessoECAC} />
          <Campo rotulo="Tipo Acesso eCAC" valor={info.tipoAcessoECAC} />
          <Campo rotulo="Código Acesso Empregador Web" valor={info.codigoAcessoEW} />
          <Campo rotulo="Senha Acesso Empregador Web" valor={info.senhaAcessoEW} />
        </div>
      </div>
    </div>
  );
}

export default GroupAcessos;
